import { useState } from "react";
import { categories, collectionData, type FeaturedItem } from "@/mocks/gossipData";

function Card({ item }: { item: FeaturedItem }) {
  return (
    <article className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200">
      <div className="relative aspect-[3/2] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-700">
          {item.category}
        </span>
      </div>
      <div className="p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-user-smile-line text-sm"></i>
            </span>
            {item.author} · {item.time}
          </span>
          <span className="inline-flex items-center gap-3 whitespace-nowrap">
            <span className="inline-flex items-center gap-1">
              <i className="ri-heart-3-fill text-primary-400"></i>
              {(item.likes / 1000).toFixed(1)}k
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {(item.comments / 1000).toFixed(1)}k
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}

export default function Collection() {
  const [active, setActive] = useState<string>("全部");

  const filtered = active === "全部" ? collectionData : collectionData.filter((c) => c.category === active);

  return (
    <section id="collection" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-grid-fill"></i>
            热门推荐 · 精选合集
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">按主题吃瓜</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            切到喜欢的频道，从综艺现场到影视口碑，慢慢挑今天想看的瓜。
          </p>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2" role="tablist" aria-label="主题分类">
          {["全部", ...categories].map((cat) => (
            <button
              key={cat}
              type="button"
              role="tab"
              aria-selected={active === cat}
              onClick={() => setActive(cat)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                active === cat
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-800"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}